import { saveAs } from 'file-saver';

export const saveJsonAsCsv = ({
  data,
  fields,
  fileformat = 'csv',
  filename = 'json-to-csv',
  separator = ',',
}) => {
  const fieldNames = Object.keys(fields);
  const header = fieldNames.map(field => fields[field]).join(separator);
  const body = data
    .map(row => fieldNames
      .map(field => Object.prototype.hasOwnProperty.call(row, field) ? row[field] : null)
      .join(separator))
    .join('\n');
  const blob = new Blob([`${header}\n${body}`], {
    type: 'text/plain;charset=utf-8',
  });

  saveAs(blob, `${filename}.${fileformat}`);
};
